import "../css/footer.scss";
import React from "react";
import { Link } from "react-router-dom";
import { FiClock, FiMail, FiMapPin } from "react-icons/fi";
import siteConfig from "../config/siteConfig";

const serviceLinks = [
  { label: "Contact", to: "/contact" },
  { label: "Shipping", to: "/shipping" },
  { label: "Returns", to: "/returns" },
  { label: "FAQs", to: "/faqs" },
  { label: "Shopping bag", to: "/cartpage" },
];

const companyLinks = [
  { label: "Our story", to: "/about" },
  { label: "Collection", to: "/shop" },
  { label: "Terms", to: "/terms" },
  { label: "Privacy", to: "/privacy" },
  { label: "Cookie policy", to: "/cookies" },
  { label: "Accessibility", to: "/accessibility" },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  const toTop = () => {
    const reduceMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
  };

  return (
    <footer
      className="site-footer"
      role="contentinfo"
      aria-label={`${siteConfig.brandName} footer`}
    >
      <div className="site-footer__body">
        <div className="site-footer__grid">
          <section
            className="site-footer__brand"
            aria-label="Brand information"
          >
            <Link to="/" onClick={toTop}>
              <img src={siteConfig.logo} alt={siteConfig.brandName} />
            </Link>
            <p>{siteConfig.description}</p>
            <span>{siteConfig.tagline}</span>
          </section>

          <nav className="site-footer__column" aria-label="Customer service">
            <h2>Service</h2>
            <ul>
              {serviceLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} onClick={toTop}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="site-footer__column" aria-label="About the company">
            <h2>About</h2>
            <ul>
              {companyLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} onClick={toTop}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <section
            className="site-footer__contact"
            aria-labelledby="footer-contact-title"
          >
            <h2 id="footer-contact-title">Contact</h2>
            <address>
              <a href={`mailto:${siteConfig.contact.email}`}>
                <FiMail aria-hidden="true" />
                <span>{siteConfig.contact.email}</span>
              </a>

              <p>
                <FiMapPin aria-hidden="true" />
                <span>
                  <strong>{siteConfig.legalName}</strong>
                  <br />
                  {siteConfig.contact.addressLines.map((line, index) => (
                    <React.Fragment key={line}>
                      {index > 0 && <br />}
                      {line}
                    </React.Fragment>
                  ))}
                </span>
              </p>
              <p>
                <FiClock aria-hidden="true" />
                <span>{siteConfig.contact.hours}</span>
              </p>
            </address>
          </section>
        </div>

        <div className="site-footer__bottom">
          <p>
            © {currentYear} {siteConfig.brandName}. All rights reserved.
          </p>
          <p>Designed for a more considered wardrobe.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
